<template>
  <base-modal
    :close-button-visible="false"
    overlay-class="modal--welcomeback modal--zero-balance"
  >
    <div class="modal__body">
      <h1>{{ getTranslations.home_modals_loading_please_wait }}</h1>

      <div class="loader-contv1">
        <div class="loader-cont__wrapperv1">
          <div class="loaderv1"></div>
        </div>
      </div>
    </div>

    <div class="modal__footer"></div>
  </base-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseModal from './BaseModal';

export default {
  name: 'BaseLoaderModal',
  components: {
    BaseModal,
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/modal/BaseLoaderModal.vue